import _ from 'lodash';
import { Dates as DateUtils } from 'arbitrip-common/client/utils';
import { useTranslation } from 'react-i18next';

const TripDetails = ({ hotel: { city, country }, searchTerms }) => {
    const { t, i18n } = useTranslation();
    const { check_in, check_out, rooms, guests, children_ages } = searchTerms;

    const CHECK_IN = DateUtils.parseFormatDate(check_in)?.locale(i18n.language).format('DD MMM YYYY');
    const CHECK_OUT = DateUtils.parseFormatDate(check_out)?.locale(i18n.language).format('DD MMM YYYY');
    const childrenCount = _.size(children_ages) * (rooms || 1);

    const ROOMS = rooms + (Number(rooms) === 1 ? ` ${t('Room')}` : ` ${t('Rooms')}`);
    const guestsNumber = (guests || 1) * (rooms || 1);
    const GUESTS = guestsNumber + (Number(guestsNumber) === 1 ? ` ${t('Adult')}` : ` ${t('Adults')}`);
    const CHILDREN = childrenCount > 0 ? `${childrenCount} ${t(childrenCount === 1 ? 'Child' : 'Children')}` : null;

    return (
        <div className="trip-details-container">
            <span className="destination">
                {' '}
                {city}, {country}
            </span>
            <div className="dates-container flex">
                <div className="flex flex-column check-in">
                    <span>{t('CheckIn')}</span>
                    <span data-testid="check-in-date">{CHECK_IN}</span>
                </div>
                <div className="flex flex-column check-out">
                    <span>{t('CheckOut')}</span>
                    <span data-testid="check-out-date">{CHECK_OUT}</span>
                </div>
            </div>
            <div className="flex flex-column guests-container">
                <span>{t('Guests')}</span>
                <span>
                    {ROOMS}&nbsp;·&nbsp;{GUESTS}
                    {CHILDREN && <>&nbsp;·&nbsp;{CHILDREN}</>}
                </span>
            </div>
        </div>
    );
};

export default TripDetails;
